export default "__VITE_ASSET__CrCm_sEe__"